@if (placing(); as placing) {
  <div
    data-testid="timeline-edit-strip"
    role="status"
    class="border-accent-border bg-accent-interactive text-accent-main flex h-full min-w-0 items-center gap-2 overflow-hidden border-b px-3 text-xs whitespace-nowrap">
    <i [class]="ICONS.crosshair + ' shrink-0 text-sm'" aria-hidden="true"></i>
    <span class="text-text-primary truncate">
      {{ 'features.plan.edit.move_stop.placing' | translate }}
      <b class="font-mono font-semibold">{{ placing.name }}</b
      >.
      @if (placing.allStops) {
        {{ 'features.plan.edit.move_stop.placing_all_stops_help' | translate }}
      } @else if (placing.kind === 'tour') {
        {{ 'features.plan.edit.move_stop.placing_tour_help' | translate }}
      } @else {
        {{
          'features.plan.edit.move_stop.placing_help' | translate: { site: placing.site }
        }}
      }
    </span>
    <span class="grow"></span>
    <span class="inline-flex shrink-0 items-center gap-1.5">
      <kbd
        class="border-accent-border bg-elevated text-text-secondary rounded-xs border px-1 font-mono text-[10.5px] leading-4"
        >{{ 'features.plan.edit.pin_drag.keys.esc' | translate }}</kbd
      >
      {{ 'features.plan.edit.pin_drag.cancels' | translate }}
    </span>
  </div>
} @else if (drag(); as drag) {
  @if (drag.mode === 'move') {
    <div
      data-testid="timeline-edit-strip"
      role="status"
      class="border-accent-border bg-accent-interactive text-accent-main flex h-full min-w-0 items-center gap-2 overflow-hidden border-b px-3 text-xs whitespace-nowrap">
      <i [class]="ICONS.arrowsOutCardinal + ' shrink-0 text-sm'" aria-hidden="true"></i>
      <span class="text-text-primary truncate">
        {{ 'features.plan.edit.move_drag.moving' | translate }}
        <b class="font-mono font-semibold">{{ drag.stopName }}</b
        >.
        @if (drag.leaveBlocked) {
          {{ 'features.plan.edit.menu.move_stop_loads_route' | translate }}
        } @else if (drag.carrying === 'tour') {
          {{ 'features.plan.edit.move_drag.drop_tour_help' | translate }}
        } @else {
          {{
            'features.plan.edit.move_drag.drop_help' | translate: { site: drag.stopName }
          }}
        }
      </span>
      <span class="grow"></span>
      <span class="inline-flex shrink-0 items-center gap-1.5">
        <kbd
          class="border-accent-border bg-elevated text-text-secondary rounded-xs border px-1 font-mono text-[10.5px] leading-4"
          >{{ 'features.plan.edit.pin_drag.keys.esc' | translate }}</kbd
        >
        {{ 'features.plan.edit.pin_drag.cancels' | translate }}
      </span>
    </div>
  } @else if (drag.mode === 'start') {
    <div
      data-testid="timeline-edit-strip"
      role="status"
      class="border-accent-border bg-accent-interactive text-accent-main flex h-full min-w-0 items-center gap-2 overflow-hidden border-b px-3 text-xs whitespace-nowrap">
      <i [class]="ICONS.play + ' shrink-0 text-sm'" aria-hidden="true"></i>
      <span class="text-text-primary truncate">
        {{ 'features.plan.edit.start_drag.moving' | translate }}
        <b class="font-mono font-semibold">{{ drag.stopName }}</b
        >.
        {{ 'features.plan.edit.start_drag.drop_help' | translate }}
      </span>
      <span class="grow"></span>
      <span class="inline-flex shrink-0 items-center gap-1.5">
        <kbd
          class="border-accent-border bg-elevated text-text-secondary rounded-xs border px-1 font-mono text-[10.5px] leading-4"
          >{{ 'features.plan.edit.pin_drag.keys.esc' | translate }}</kbd
        >
        {{ 'features.plan.edit.pin_drag.cancels' | translate }}
      </span>
    </div>
  } @else if (drag.mode === 'reorder') {
    <div
      data-testid="timeline-edit-strip"
      role="status"
      class="border-accent-main bg-accent-main text-text-on-accent flex h-full min-w-0 items-center gap-2 overflow-hidden border-b px-3 text-xs whitespace-nowrap">
      <i [class]="ICONS.listNumber + ' shrink-0 text-sm'" aria-hidden="true"></i>
      <span class="truncate">
        {{ 'features.plan.edit.reorder_drag.reordering' | translate }}
        <b class="font-mono font-semibold">{{ drag.stopName }}</b
        >.
        {{ 'features.plan.edit.reorder_drag.drop_in_route_gap' | translate }}
      </span>
      <span class="grow"></span>
      <span class="hidden shrink-0 items-center gap-1.5 md:inline-flex">
        <kbd class="key-chip is-pressed">{{ altKey | translate }}</kbd>
        {{ 'features.plan.edit.reorder_drag.held' | translate }}
      </span>
    </div>
  } @else {
    <div
      data-testid="timeline-edit-strip"
      role="status"
      class="border-accent-border bg-accent-interactive text-accent-main flex h-full min-w-0 items-center gap-2 overflow-hidden border-b px-3 text-xs whitespace-nowrap">
      <i [class]="ICONS.pushPin + ' shrink-0 text-sm'" aria-hidden="true"></i>
      <span class="text-text-primary truncate">
        {{ 'features.plan.edit.pin_drag.pinning' | translate }}
        <b class="font-mono font-semibold">{{ drag.stopName }}</b
        >.
        {{ 'features.plan.edit.pin_drag.drop_to_pin' | translate }}
      </span>
      <span class="grow"></span>
      <span class="hidden shrink-0 items-center gap-1.5 md:inline-flex">
        {{ 'features.plan.edit.pin_drag.hold' | translate }}
        <kbd class="key-chip">{{ altKey | translate }}</kbd>
        {{ 'features.plan.edit.pin_drag.to_reorder_instead' | translate }}
      </span>
      <span class="inline-flex shrink-0 items-center gap-1.5">
        <kbd
          class="border-accent-border bg-elevated text-text-secondary rounded-xs border px-1 font-mono text-[10.5px] leading-4"
          >{{ 'features.plan.edit.pin_drag.keys.esc' | translate }}</kbd
        >
        {{ 'features.plan.edit.pin_drag.cancels' | translate }}
      </span>
    </div>
  }
}
